import { render } from "./FundNewer.vue?vue&type=template&id=0734fd6d"
import script from "./FundNewer.vue?vue&type=script&lang=js"
export * from "./FundNewer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__